import React from 'react'
import {
  Button,
  Modal,
  Header,
  Table,
  Checkbox,
} from 'semantic-ui-react'
import Selector from './Selector.js'
import {cloneType} from './type.js'

class TypePresetsModal extends React.Component {
  constructor(props) {
    super(props);
    // props: typePresets, open, onSubmit, onCancel
    this.state = {
      index: 0,
      exampleItem: {},
    }
  }
  handleSubmit = ()=>{
    console.log("TypePresetsModal::handleSubmit()");
    console.log("state:", this.state);
    const type = cloneType(this.props.typePresets[this.state.index]);
    this.props.onSubmit(type);
  }
  render() {
    return (
      <Modal
        open={this.props.open}
        closeOnEscape={true}
        closeOnDimmerClick={true}
        onClose={this.props.onCancel}
      >
        <Header as='h2' icon='browser' content='Pick a Selection Type' />
        <Modal.Content>
          <Table selectable>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell collapsing></Table.HeaderCell>
                <Table.HeaderCell collapsing>Name</Table.HeaderCell>
                <Table.HeaderCell>Example</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {
                this.props.typePresets.map((t,i)=>
                  <Table.Row
                    key={i}
                    warning={i===this.state.index}
                    onClick={()=>{this.setState({index: i})}}
                  >
                    <Table.Cell collapsing>
                      <Checkbox radio checked={i===this.state.index}/>
                    </Table.Cell>
                    <Table.Cell collapsing>
                      {
                        t.map(e=>e.name).join(' | ')
                      }
                    </Table.Cell>
                    <Table.Cell>
                      <Selector
                        type={t}
                        colorAll={true}
                        onToggleItem={(eid,cid)=>{console.log("toggle", eid, cid)}}
                      />
                    </Table.Cell>
                  </Table.Row>
                )
              }
            </Table.Body>
          </Table>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={this.props.onCancel}>Cancel</Button>
          <Button primary onClick={this.handleSubmit}>Update</Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

export default TypePresetsModal